import { CurrencyPipe, DatePipe, DecimalPipe } from '@angular/common';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import {
  ApplicationConfig,
  importProvidersFrom,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
  provideRouter,
  withInMemoryScrolling,
  withPreloading,
  withRouterConfig,
} from '@angular/router';
import {
  AaNgModule,
  INSTITUTION_CONTEXT_TOKEN,
  PERSON_URL_PIPE_TOKEN,
  StripHtmlPipe,
} from 'aa-ng';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha-2';
import { QuicklinkModule, QuicklinkStrategy } from 'ngx-quicklink';

import { environment } from '../environments/environment';
import { APP_ROUTES } from './app.routes';
import { InstitutionContextResolver } from './institution-context.resolver';
import {
  EnumToArrayPipe,
  InstitutionsService,
  PersonUrlPipe,
  ResearchAtAGlanceActivityTypeTitlePipe,
} from './shared';
import { CacheInterceptor } from './shared/services/interceptors/cache.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection(),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    provideRouter(
      APP_ROUTES,
      withInMemoryScrolling({ scrollPositionRestoration: 'top' }),
      withRouterConfig({ paramsInheritanceStrategy: 'always' }),
      withPreloading(QuicklinkStrategy),
    ),
    importProvidersFrom(AaNgModule, RecaptchaV3Module, QuicklinkModule),
    InstitutionContextResolver,
    { provide: INSTITUTION_CONTEXT_TOKEN, useClass: InstitutionsService },
    { provide: PERSON_URL_PIPE_TOKEN, useClass: PersonUrlPipe },
    { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.recaptchaSiteKey },
    { provide: HTTP_INTERCEPTORS, useClass: CacheInterceptor, multi: true },
    CurrencyPipe,
    DecimalPipe,
    DatePipe,
    PersonUrlPipe,
    ResearchAtAGlanceActivityTypeTitlePipe,
    EnumToArrayPipe,
    StripHtmlPipe,
  ],
};
